import React from "react";
import { HashLoader } from "react-spinners";

const LoadingSpinner = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(136, 133, 133, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <HashLoader
        color="#d0ffc8"
        loading={isLoading}
        size={60}
        speedMultiplier={1}
      />
    </div>
  );
};

export default LoadingSpinner;
